import {useContext, createContext} from 'react'

interface AccordionContextType {
    shouldExpandDetails: (index: number) => boolean
    itemIndex: number
    arrowDirection?: 'right' | 'down'
    highlightExpandedItem?: boolean
}

export const AccordionContext = createContext<AccordionContextType | undefined>(undefined)

export const useAccordionContext = () => {
    const context = useContext(AccordionContext)
    if (!context) {
        throw new Error(
            "useAccordionContext must be used within an AccordionProvider. Please ensure all accordion-related components are nested within 'Accordion'"
        )
    }
    return context
}
